module.exports = __webpack_public_path__ + "img/ada-badge-2013_en.45400eb.svg";